import * as React from 'react'

import { QuestionWrapper } from '../form.styles'
import {
  ArrowDownIconStyled,
  Caption,
  CaptionText,
  ErrorMessage,
  Label,
  OptionField,
  SelectField,
  Wrapper,
} from './NativeSelect.styles'
import { Option } from './NativeSelect.types'

interface Props extends React.SelectHTMLAttributes<any> {
  value: number | string
  label: string
  question?: string
  name: string
  hasError?: boolean
  errorMsg?: string
  required?: boolean
  options: Option[]
  forceFullText?: boolean
}

interface State {
  hasFocus: boolean
}

class NativeSelect extends React.Component<Props, State> {
  state = { hasFocus: false }

  onFocus = event => {
    this.setState({ hasFocus: true })
  }

  onBlur = event => {
    this.setState({ hasFocus: false })
  }

  render() {
    const {
      label,
      question,
      name,
      value,
      required = false,
      hasError,
      errorMsg,
      onChange,
      options,
      forceFullText,
    } = this.props

    const { hasFocus } = this.state
    const hasValue = Boolean(
      value &&
        (typeof value === 'number' ||
          (typeof value === 'string' && value.trim().length > 0)),
    )
    const caption =
      hasValue &&
      options.filter(option =>
        typeof option.value === 'number'
          ? option.value === Number(value)
          : option.value === value,
      )[0].text
    return (
      <>
        {question && (
          <QuestionWrapper as="div" color="black">
            {question}
          </QuestionWrapper>
        )}
        <Wrapper>
          <Label required={required} elevated={hasValue}>
            {label}
          </Label>
          <SelectField
            name={name}
            onChange={onChange}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            value={value}
          >
            {options.map(option => (
              <OptionField
                key={option.value}
                value={option.value}
                disabled={option.disabled}
              >
                {option.text}
              </OptionField>
            ))}
          </SelectField>
          <Caption hasError={hasError}>
            <CaptionText forceFullText>{caption}</CaptionText>
            <ArrowDownIconStyled hasError={hasError} />
          </Caption>
        </Wrapper>
        {hasError && <ErrorMessage>{errorMsg}</ErrorMessage>}
      </>
    )
  }
}

export default NativeSelect
